export default "__VITE_ASSET__Cpmk$iI$__"